import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
} from "@material-ui/core";
import { useFormik } from "formik";
import MuiPhoneNumber from "material-ui-phone-number";
import { object, SchemaOf, string } from "yup";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { AddData } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ICompanyProfileItem } from "src/common/typings/companyProfile";
import AsynCommonAutoCompleteField from "src/components/CommonAutoCompleteField/AsynCommonAutoCompleteField";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};
const validationSchema: SchemaOf<{ contactEmail: string }> = object({
  contactEmail: string().email("Must be a valid email").max(255).default("").defined("").nullable(),
});
export function ProfileInfo({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [profileInfo, setProfileInfo] = useState<ICompanyProfileItem | any>({});
  const [editcp, setEditcp] = useState(false);
  const [fristTimeExpend, setFristTimeExpend] = useState(false);
  const [states, setStates] = useState<any>();
  const [cities, setCities] = useState<any>();
  const [states1, setStates1] = useState<any>();
  const [cities1, setCities1] = useState<any>();
  const formik = useFormik<ICompanyProfileItem>({
    enableReinitialize: false,
    initialValues: {
      address: "",
      city: "",
      zip: "",
      state: "",
      company: "",
      contactEmail: "",
      contactPerson: "",
      fax: "",
      mailingAddress: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: "",
      mailingCompany: "",
      phone: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const clone = JSON.parse(JSON.stringify(values));
      if (clone.phone) clone.phone = clone.phone.replace(/[()' '-]/g, "");
      setLoader(true);
      const body = {
        ...clone,
      };
      try {
        await dispatch(
          AddData(
            "/update-vendor-detail-by-vend-num",
            "Company profile successfully",
            JSON.stringify(body)
          )
        );
        setEditcp(false);
        getOrderInfoData();
      } catch (error) {
        setLoader(false);
      }
      setLoader(false);
    },
  });
  const getOrderInfoData = async () => {
    try {
      setLoader(true);
      const results = (await fetchWrapper.get(
        "get-vendor-detail-by-vend-num"
      )) as ICompanyProfileItem;
      setProfileInfo(results);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const resetStatesAndCities = async () => {
    setLoader(true);
    const { states } = await fetchWrapper.get("/get-states");
    const { cities } = await fetchWrapper.get("/get-cities");
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates(res);
    setStates1(res);
    setCities(cities || []);
    setCities1(cities || []);
    setLoader(false);
    setFristTimeExpend(true);
  };
  const getValueWRTzip = async (zip: string) => {
    setLoader(true);
    const { data } = await fetchWrapper.get(`/get-cities-states-counties-by-zip/${zip || ""}`);
    const { states, cities } = data;
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates(res);
    setCities(cities ? cities : []);
    setLoader(false);
  };
  const getValueWRTzip1 = async (zip: string) => {
    setLoader(true);
    const { data } = await fetchWrapper.get(`/get-cities-states-counties-by-zip/${zip || ""}`);
    const { states, cities } = data;
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates1(res);
    setCities1(cities || []);
    setLoader(false);
  };
  const getCitiesWRTstate = async (st: string) => {
    setLoader(true);
    const { cities } = await fetchWrapper.get(`/get-cities/${st || ""}`);
    setCities(cities || []);
    setLoader(false);
  };
  const getCitiesWRTstate1 = async (st: string) => {
    setLoader(true);
    const { cities } = await fetchWrapper.get(`/get-cities/${st || ""}`);
    setCities1(cities || []);
    setLoader(false);
  };

  useEffect(() => {
    if (expand) {
      getOrderInfoData();
      if (!fristTimeExpend) {
        resetStatesAndCities();
      }
    }
  }, [expand]);
  const { setValues, values, submitForm } = formik;
  const {
    address,
    city,
    zip,
    state,
    contactPerson,
    fax,
    mailingAddress,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCompany,
    phone,
    contactEmail,
  } = values;

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(0)}>
          <Heading heading="Profile" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                {Boolean(Object.keys(profileInfo).length) ? (
                  <Card
                    InfoData={profileInfo || {}}
                    editCompany={() => {
                      const clone = JSON.parse(JSON.stringify(profileInfo));
                      formik.setValues(clone);
                      setEditcp(true);
                    }}
                  />
                ) : (
                  <NoRecordFound />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Grid container direction="row" spacing={1}>
        <CommonDrawer
          heading={"Profile"}
          isOpen={editcp}
          closeDrawer={() => {
            setEditcp(false);
          }}
          drawerWidth={550}
        >
          <Box mt={2} />
          <Grid container spacing={2} direction="row">
            <Grid item xs={12}>
              <Box color="text.primary">
                <Typography component="label" variant="body1">
                  Company
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <CommonTextField
                // required
                label="Address"
                onChange={(v: any) => {
                  setValues({ ...values, address: v.target.value });
                }}
                name="address"
                value={address}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AsynCommonAutoCompleteField
                label="City"
                name="city"
                optionsType={cities?.length ? cities : []}
                getOptionLabel={(option: any) => option || ""}
                value={cities && cities?.length ? cities.find((cit: any) => cit === city) : null}
                handleChange={(v) => {
                  setValues({ ...values, city: v });
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CommonAutoCompleteField
                label="State"
                name="state"
                optionsType={states || []}
                getOptionLabel={(option: any) => option.label || ""}
                value={states?.find(({ value }: any) => value === state) || null}
                onChange={(option: any) => {
                  if (!option?.value) {
                    setValues({
                      ...values,
                      state: "",
                      zip: "",
                      city: "",
                    });
                    resetStatesAndCities();
                  } else {
                    setValues({ ...values, state: option?.value || "" });
                    if (!values.zip) getCitiesWRTstate(option?.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                // required
                label="Zip"
                onChange={(v: any) => {
                  setValues({ ...values, zip: v.target.value });
                }}
                onBlur={(e: any) => {
                  if (e.currentTarget.value) {
                    setValues({
                      ...values,
                      zip: e.currentTarget.value,
                    });
                    getValueWRTzip(e.currentTarget.value);
                  } else {
                    resetStatesAndCities();
                  }
                }}
                name="zip"
                value={zip}
              />
            </Grid>
            <Grid item xs={12}>
              <Box color="text.primary">
                <Typography component="label" variant="body1">
                  Contact
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Contact Person"
                onChange={(v: any) => {
                  setValues({ ...values, contactPerson: v.target.value });
                }}
                name="contactPerson"
                value={contactPerson}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Contact Email"
                onChange={(v: any) => {
                  setValues({ ...values, contactEmail: v.target.value });
                }}
                error={formik.touched.contactEmail && Boolean(formik.errors.contactEmail)}
                helperText={formik.touched.contactEmail && formik.errors.contactEmail}
                name="contactEmail"
                value={contactEmail}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MuiPhoneNumber
                defaultCountry={"us"}
                name="phone"
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                type="tel"
                label="Phone"
                value={phone}
                onChange={(v: any) => {
                  setValues({ ...values, phone: v });
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Fax"
                onChange={(v: any) => {
                  setValues({ ...values, fax: v.target.value });
                }}
                type="number"
                name="fax"
                value={fax}
              />
            </Grid>
            <Grid item xs={12}>
              <Box color="text.primary">
                <Typography component="label" variant="body1">
                  Check Address
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Company"
                onChange={(v: any) => {
                  setValues({ ...values, mailingCompany: v.target.value });
                }}
                name="mailingCompany"
                value={mailingCompany}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Address"
                onChange={(v: any) => {
                  setValues({ ...values, mailingAddress: v.target.value });
                }}
                name="mailingAddress"
                value={mailingAddress}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AsynCommonAutoCompleteField
                label="City"
                name="mailingCity"
                optionsType={cities1}
                getOptionLabel={(option: any) => option || ""}
                value={
                  cities1 && cities1?.length
                    ? cities1.find((city: any) => city === mailingCity)
                    : null
                }
                handleChange={(v) => {
                  setValues({ ...values, mailingCity: v });
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CommonAutoCompleteField
                label="State"
                name="mailingState"
                optionsType={states1}
                getOptionLabel={(option: any) => option.label || ""}
                value={states1?.find(({ value }: any) => value === mailingState) || null}
                onChange={(option: any) => {
                  if (!option?.value) {
                    setValues({
                      ...values,
                      mailingState: "",
                      mailingZip: "",
                      mailingCity: "",
                    });
                    resetStatesAndCities();
                  } else {
                    setValues({ ...values, mailingState: option?.value || "" });
                    if (!values.mailingZip) getCitiesWRTstate1(option?.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                // required
                label="Zip"
                onChange={(v: any) => {
                  setValues({ ...values, mailingZip: v.target.value });
                }}
                onBlur={(e: any) => {
                  if (e.currentTarget.value) {
                    setValues({
                      ...values,
                      mailingZip: e.currentTarget.value,
                    });
                    getValueWRTzip1(e.currentTarget.value);
                  } else {
                    resetStatesAndCities();
                  }
                }}
                name="mailingZip"
                value={mailingZip}
              />
            </Grid>
            <Grid item xs={12}>
              <Box mt={2} mb={2} textAlign="right">
                <Box component="span" mr={2}>
                  <CommonButton
                    onClick={() => {
                      setEditcp(false);
                    }}
                  >
                    Cancel
                  </CommonButton>
                </Box>
                <Box component="span">
                  <CommonButton
                    isGreen
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CommonDrawer>
      </Grid>
    </>
  );
}
